import { UPDATE_LEGACY_LOANS_DATA } from '@/store/modules/legacyLoansData/routines'

export default {
  [UPDATE_LEGACY_LOANS_DATA](state, payload) {
    state.legacyLoansData = payload
  }
}
